module.exports = __webpack_public_path__ + "media/bootstrap-icons/check-circle-f93cc3a8.svg";